import { useTranslation } from '@frontend/i18n';
import { settingsTrackingIds } from '@frontend/schedule-helpers';
import { SettingsLink, useSettingsNavigate } from '@frontend/settings-routing';
import { SettingsGroup } from '@frontend/settings-ui';
import { IndexRow, Text } from '@frontend/design-system';
import { useSchedulingLocationInfo } from '../../hooks/use-scheduling-location-info';

export const MultiLocationAvailabilityPage = () => {
  const { t } = useTranslation('schedule-settings');
  const { navigate } = useSettingsNavigate();
  const { getScopeName, selectedLocationIds } = useSchedulingLocationInfo();

  const navigateTo = (locationId = '') => {
    navigate({
      to: '/schedule/availability/:locationId',
      params: { locationId },
    });
  };

  return (
    <SettingsGroup title={t('Location Settings')}>
      <IndexRow>
        {selectedLocationIds?.map((locationId) => (
          <IndexRow.Item
            key={locationId}
            as={SettingsLink}
            to='/schedule/availability/:locationId'
            onClick={() => navigateTo(locationId)}
            trackingId={settingsTrackingIds.availabilityRowItem}
          >
            <IndexRow.Item.Title>
              <div css={{ display: 'flex', alignItems: 'center', width: '100%' }}>
                <Text>{getScopeName(locationId)}</Text>
                {/* TODO: Show count when API is available */}
              </div>
            </IndexRow.Item.Title>
          </IndexRow.Item>
        ))}
      </IndexRow>
    </SettingsGroup>
  );
};
